import {
  Box,
  Button,
  Image,
  Stack,
  Text,
  useColorModeValue,
} from "@chakra-ui/react";
import { useNavigate } from "react-router-dom";
import useSmallScreen from "../../../components/useSmallScreen";

function  LiveStreamCard({data}) {
  const navigate = useNavigate();
  const modeBg = useColorModeValue("#fff", "#030c1b");
  const modeBoxShadow = useColorModeValue("#80808024", "#030c1b");
  const text2Color = useColorModeValue("#707070", "#707070");

  const redColor = useColorModeValue("#FF686B", "#FF4246");
  const [smallScreen] = useSmallScreen();
  console.log('inside data',data)

  return (
    <Stack
      maxW={smallScreen ? "unset" : "150px"}
      minW={smallScreen ? "150px" : "150px"}
      flex={["1", "unset"]}
      borderRadius={"15px"}
      boxShadow={`2px 2px 14px 0px ${modeBoxShadow}`}
      p="5px"
      bg={modeBg}
      spacing="1"
    >
      <Box
        position={"relative"}
        display="flex"
        justifyContent={"center"}
        alignItems="center"
      >
        <Image
          boxShadow={`2px 2px 14px 0px ${modeBoxShadow}`}
          borderRadius={"20px"}
          w="170px"
          maxW={"170px"}
          h="100px"
          maxH={"100px"}
          objectFit={"cover"}
          src= {data?.url?data?.url:""}
         
          alt="random user pic"
          // fallbackSrc="https://via.placeholder.com/150"
        />
      </Box>
      <Stack alignItems="flex-start" spacing={"1"}>
        <Text fontWeight={"bold"} fontSize=".85em">
         {data?.user?.username}
        </Text>
        <Text color={text2Color} fontSize={".6em"} pb="10px" textAlign={"left"}>
         {data?.title}
        </Text>
      </Stack>
      <Stack
        justifyContent={"space-between"}
        direction="row"
        alignItems={"center"}
        p="0 5px"
      >
        <Text color="#0076FF" fontSize={".8em"}>
          {/* $2.00 */}
        </Text>
        <Button
          size="xs"
          h="25px"
          w="70px"
          fontWeight={"700"}
          bg={redColor}
          color="#fff"
          onClick={() =>
            navigate("/view-stream", { state: { room: data?.title,streamer: data?.user?.username} })
          }
        >
          View
        </Button>
      </Stack>
    </Stack>
  );
}

export default LiveStreamCard;
